import { Component, Injectable, OnInit} from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/common.service';
import Swal from 'sweetalert2';
declare let swal: any;
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-mebanklogin',
  templateUrl: './mebanklogin.component.html',
  styleUrls: ['./mebanklogin.component.css'],
})
export class MeBankLoginComponent implements OnInit {

  model: any = {};
  mebankmodel: any = {};
  activateModel: any = {};
  data:any={};
  entered:any;
  users :any= [];
  userRestApiUrl: string = AppSettings.checkmebanklogin;
  getpackageinfodetApiUrl:string = AppSettings.getPackageInfo; 
  updatemebankpwdApiUrl:string = AppSettings.updatemebankpwd;
  activatemebankApiUrl:string = AppSettings.activatemebank;
  currentUser:any=localStorage.getItem('currentUser');
  currentUserID:any=localStorage.getItem('currentUserID');
  currentUsername:any=localStorage.getItem('currentUser');
  currentUsergroup:any=localStorage.getItem('currentUsergroup');
  userRole:any=localStorage.getItem('userRole');
  packagelist:Array<Object>;
  mebankpwd:any="";
  mebankstatus:any=null;
  mebankshow:any=null;
  mebankLoaded:boolean=false;
  showActivateForm:boolean=false;
  FetchuserRestApiUrl: string = AppSettings.Edituser;

  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) {

    document.body.className="mebank-login-page";

   }

  ngOnInit() {
     this.currentUsername = localStorage.getItem('currentUser');
     if(this.currentUsername==null || this.currentUsername==undefined || this.currentUsername==''){
        this.router.navigate(['/login']);
        return;
     }
     this.entered = 0;
     this.model.user_name=this.currentUsername;
     this.activateModel.username=this.currentUsername;

     let user_id = localStorage.getItem('currentUserID');
       
       this.model.user_id = user_id;
      this.CommonService.editdata(this.FetchuserRestApiUrl,user_id)
          .subscribe(userdet =>{
            if(userdet.result){
              this.mebankstatus=Number(userdet.result.mebankstatus);
              this.mebankshow=Number(userdet.result.mebankshow);
              if(userdet.result.mebankpwd!=null && userdet.result.mebankpwd!=''){
                this.mebankpwd=userdet.result.mebankpwd;
              }else{
                this.mebankpwd='';
              }
            }
            this.mebankLoaded=true;
            if(this.mebankshow==1 && localStorage.getItem('mebankLogin') != null && this.mebankstatus==1){
              this.router.navigate(['./mebankdashboard']);
            }
          });
      this.CommonService.editdata(this.getpackageinfodetApiUrl,user_id)
          .subscribe(resultdata =>{   
            this.packagelist=resultdata.result; 
            if(resultdata.result && resultdata.result[0]){
              this.model.tot_amt=resultdata.result[0]['tamount']; 
              this.model.tamount_renewal=resultdata.result[0]['tamount_renewal'];
              this.model.instructor_amount=resultdata.result[0]['instructor_amount'];
              this.model.instructor_amount_renewal=resultdata.result[0]['instructor_amount_renewal'];
              this.model.e_amt=resultdata.result[0]['eamount'];
              this.model.eamount_renewal=resultdata.result[0]['eamount_renewal']; 
              this.model.pw_amount=resultdata.result[0]['pw_amount'];
              this.model.pw_amount_renewal=resultdata.result[0]['pw_amount_renewal'];
              this.model.bw_amount=resultdata.result[0]['bw_amount'];
              this.model.bw_amount_renewal=resultdata.result[0]['bw_amount_renewal'];
              this.model.mall_amount=resultdata.result[0]['mall_amount'];
              this.model.mall_amount_renewal=resultdata.result[0]['mall_amount_renewal'];
              this.model.floor_amount=resultdata.result[0]['floor_amount'];
              this.model.floor_amount_renewal=resultdata.result[0]['floor_amount_renewal'];
              this.model.shop_amount=resultdata.result[0]['shop_amount'];
              this.model.shop_amount_renewal=resultdata.result[0]['shop_amount_renewal'];
              this.model.me_ai_amount=resultdata.result[0]['me_ai_amount'];
              this.model.dollar_amount=resultdata.result[0]['dollar_amount']; 
              this.model.growME=resultdata.result[0]['growME']; 
              this.model.ai_dollar=resultdata.result[0]['ai_dollar'];
            }
            });
  }

  public loadScript(url) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  openActivateForm(){
    this.showActivateForm=true;
    this.activateModel.username=this.currentUsername;
    this.activateModel.password='';
    this.activateModel.mebankpwd='';
  }

  cancelActivateForm(){
    this.showActivateForm=false;
    this.activateModel.password='';
    this.activateModel.mebankpwd='';
  }

  payAndActivate(){
    if(!this.activateModel.password){
      swal('Oops...', 'Enter valid AI Intenet Key', 'error');
      return;
    }
    if(!this.activateModel.mebankpwd){
      swal('Oops...', 'Enter New AI Internet Bank Key', 'error');
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: "Pay 100 AI Internet Money to activate your AI Internet Bank",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Pay and Activate'
    }).then((result) => {
      if (result.value) {
        this.payAndActivateConfirm();
      }
    })
  }

  payAndActivateConfirm(){
    let postData = {
      username: this.currentUsername,
      password: this.activateModel.password,
      mebankpwd: this.activateModel.mebankpwd
    };
    this.CommonService.updatedata(this.activatemebankApiUrl, postData)
    .subscribe(resultdata =>{
      if(resultdata.status==1){
        swal('', resultdata.message || 'AI Internet Bank activated successfully', 'success');
        this.mebankstatus=1;
        this.mebankpwd=this.activateModel.mebankpwd;
        this.showActivateForm=false;
        this.model.user_password='';
      }else{
        swal('Oops...', resultdata.message || 'Enter valid Internet Key', 'error');
      }
    });
  }

   enterlogin()
  {
    if(this.entered==0)
    {
      this.checkmebanklogin();
      this.entered=1;
    }
    if(this.entered==1)
    {
      this.entered=0;
    }
  }  

  updatemebankpwd(){
    if(this.mebankmodel.user_password==undefined || this.mebankmodel.user_password==null || this.mebankmodel.user_password==''){
      swal('Oops...', 'Please Enter AI Internet Bank Key', 'error');
      return false;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to update AI Internet Bank Key!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!'
    }).then((result) => {
      if (result.value) {
        this.updatemebankpwdconfirm();
      }
    })
    
  }

  updatemebankpwdconfirm(){
    let user_id = localStorage.getItem('currentUserID');
    this.mebankmodel.user_id = user_id;
    this.CommonService.updatedata(this.updatemebankpwdApiUrl,this.mebankmodel)
    .subscribe(resultdata =>{   
        this.packagelist=resultdata.result; 
        if(resultdata.status==1 || resultdata.status=='success'){
          swal('', resultdata.message || 'AI Internet Bank Key Updated Successfully', 'success');
          this.router.navigate(['./dashboard']);
        }else{
          swal('Oops...', resultdata.message || 'Please Activate ME Bank and Update AI Internet Bank Key', 'error');
        }
      });
  }

  checkmebanklogin(){
    let usernme = null;
    let userpass = null;
    usernme = this.currentUsername;
    userpass = this.model.user_password;
    if((usernme==undefined || usernme==null)&&(userpass==undefined || userpass==null))
    {
      swal('Oops...', 'Enter Valid AI Internet Bank Key', 'error');
      
      if(this.entered==0)
      {
        this.entered=1;
      }
    }
    else 
    {
      if(usernme!=null && userpass!=null){
          this.CommonService.checkexistdata(this.userRestApiUrl,this.model).subscribe(data=>{
              if(data.exist==1)
              {
                let user_det = data.result[0];
                let chatcode = localStorage.getItem('chatcode');

                localStorage.setItem('currentUser', user_det.username);
                localStorage.setItem('currentUserID', user_det.id);
                localStorage.setItem('currentUsergroup',user_det.user_type);
                localStorage.setItem('usergroup',user_det.user_type);
                localStorage.setItem('user_fname',user_det.fname);
                localStorage.setItem('email',user_det.email);
                localStorage.setItem('address',user_det.address);
                localStorage.setItem('tamount',user_det.tamount);
                localStorage.setItem('pcktaken',user_det.pcktaken);
                localStorage.setItem('userRole',user_det.packInfo.website_type);
                localStorage.setItem('mebankshow', user_det.mebankshow);
                localStorage.setItem('mebankstatus', user_det.mebankstatus);
                
                if(user_det.mebankstatus==1){
                  localStorage.setItem('mebankLogin',user_det.mebankstatus);
                  if((user_det.user_type==1)&&(chatcode==null))
                  {
                    this.router.navigate(['./admindashboard']);
                  }
                  else if(user_det.user_type==3)
                  {
                    this.router.navigate(['./admindashboard']);
                  }
                  else if(chatcode!=null)
                  {
                    this.router.navigate(['/chat']);
                  }
                  else{
                    this.router.navigate(['./mebankdashboard']);
                  }
                }
                else{
                  swal('Oops...', "AI Internet Bank is not active for this user", 'error');
                }
              }
              else
              {
                swal('Oops...', "Enter Valid AI Internet Bank Key to Login", 'error');
              }
          });
        
      }
    }
  }


  logout() {      
        localStorage.removeItem('mebankLogin');
        this.router.navigate(['./mebankdashboard']);
    }


}
